import { render, staticRenderFns } from "./GoodModal.vue?vue&type=template&id=26540624&"
import script from "./GoodModal.vue?vue&type=script&lang=js&"
export * from "./GoodModal.vue?vue&type=script&lang=js&"
import style0 from "./GoodModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports